import React from 'react';
//import InputRange from 'react-input-range';
import Dropdown from 'react-dropdown';
import { Scrollbars } from 'react-custom-scrollbars';
// import { toast } from 'react-toastify';
import toast from '../../components/Toastify';
import { PostToggleCard, SelectTemplateCard, CtaLableCard, CustomWidthCard, UpgradePlanCard } from '../../components';

// start quill
import ReactQuill, { Quill } from 'react-quill';
// import 'react-quill/dist/quill.snow.css';

// Add fonts to whitelist
// setTimeout(() => {
let Font = Quill.import('formats/font');
Font.whitelist = ['OpenSans', 'Lato', 'Poppins', 'Raleway', 'Roboto', 'CircularStdBook', 'WebsiteFont'];
Quill.register(Font, true);

const objKeyboard = {
  bindings: {
    tab: false,
    custom: {
      key: 13,
      shiftKey: true,
      handler: function () { /** do nothing */ }
    },
    handleEnter: {
      key: 13,
      handler: function () { /** do nothing */ }
    },
    handleMouseClick: {
      handler: function () { console.log('click'); }
    }
  }
};

const customHandler = {
  'color': function (value) {
    if (value == 'custom-color') value = window.prompt('Enter Hex Color Code');
    this.quill.format('color', value, 'user');
  },
  'background': function (value) {
    if (value == 'custom-background') value = window.prompt('Enter Hex Color Code');
    this.quill.format('background', value, 'user');
  },
  'custTagDropDown': function (value) {
    if (this.quill.getText().includes(value) != true)
      this.quill.insertText(this.quill.getSelection().index, '{{' + value + '}}', 'user');
    else
      toast.error('{{' + value + '}} alreary available');
  }
};

const toolbarModuleWithoutFontSize = {
  container: [
    [{ 'custTagDropDown': [] }],
    ['bold', 'italic', 'underline'],
    ['link', 'clean'],
  ],
  handlers: customHandler
};

//toolbar module for floating badge layout
const toolbarForFloatingBadge = {
  container: [
    [{ 'custTagDropDown': [] }],
    ['bold', 'italic', 'underline'],
    ['link', 'clean'],
  ],
  handlers: customHandler
};

//for load more btn and post wiget header and caption 
const toolbarModuleFontSize = {
  container: [
    [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
    [{ 'font': ['OpenSans', 'Lato', 'Poppins', 'Raleway', 'Roboto', 'CircularStdBook', 'WebsiteFont'] }],
    [{ 'align': [] }],
    ['bold', 'italic', 'underline'],
    [
      { 'color': ['#000000', '#e60000', '#ff9900', '#ffff00', '#008a00', '#0066cc', '#9933ff', '#ffffff', '#facccc', '#ffebcc', '#ffffcc', '#cce8cc', '#cce0f5', '#ebd6ff', '#bbbbbb', '#f06666', '#ffc266', '#ffff66', '#66b966', '#66a3e0', '#c285ff', '#888888', '#a10000', '#b26b00', '#b2b200', '#006100', '#0047b2', '#6b24b2', '#444444', '#5c0000', '#663d00', '#666600', '#003700', '#002966', '#3d1466', 'custom-color'] },
      { 'background': ['#000000', '#e60000', '#ff9900', '#ffff00', '#008a00', '#0066cc', '#9933ff', '#ffffff', '#facccc', '#ffebcc', '#ffffcc', '#cce8cc', '#cce0f5', '#ebd6ff', '#bbbbbb', '#f06666', '#ffc266', '#ffff66', '#66b966', '#66a3e0', '#c285ff', '#888888', '#a10000', '#b26b00', '#b2b200', '#006100', '#0047b2', '#6b24b2', '#444444', '#5c0000', '#663d00', '#666600', '#003700', '#002966', '#3d1466', 'custom-background'] },
      'link', 'clean'],
  ],
  handlers: customHandler
};


const modulesFloatingBadgeQuill = {
  toolbar: toolbarForFloatingBadge,
  keyboard: objKeyboard
};

// for prevent enter key
const modulesPreventEnterQuill = {
  toolbar: toolbarModuleWithoutFontSize,
  keyboard: objKeyboard
};

//for load more btn
const modulesFontSizeQuill = {
  toolbar: toolbarModuleFontSize,
  keyboard: objKeyboard
};


const modulesQuill = {
  toolbar: {
    container: [
      [{ 'align': [] }],
      ['bold', 'italic', 'underline'],
      ['link', 'clean'],
    ]
  }
};

const modulesQuillForWriteReview = {
  toolbar: {
    container: [
      [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
      [{ 'font': ['OpenSans', 'Lato', 'Poppins', 'Raleway', 'Roboto', 'CircularStdBook', 'WebsiteFont'] }],
      [{ 'align': [] }],
      ['bold', 'italic', 'underline'],
      [
        { 'color': ['#000000', '#e60000', '#ff9900', '#ffff00', '#008a00', '#0066cc', '#9933ff', '#ffffff', '#facccc', '#ffebcc', '#ffffcc', '#cce8cc', '#cce0f5', '#ebd6ff', '#bbbbbb', '#f06666', '#ffc266', '#ffff66', '#66b966', '#66a3e0', '#c285ff', '#888888', '#a10000', '#b26b00', '#b2b200', '#006100', '#0047b2', '#6b24b2', '#444444', '#5c0000', '#663d00', '#666600', '#003700', '#002966', '#3d1466', 'custom-color'] },
        { 'background': ['#000000', '#e60000', '#ff9900', '#ffff00', '#008a00', '#0066cc', '#9933ff', '#ffffff', '#facccc', '#ffebcc', '#ffffcc', '#cce8cc', '#cce0f5', '#ebd6ff', '#bbbbbb', '#f06666', '#ffc266', '#ffff66', '#66b966', '#66a3e0', '#c285ff', '#888888', '#a10000', '#b26b00', '#b2b200', '#006100', '#0047b2', '#6b24b2', '#444444', '#5c0000', '#663d00', '#666600', '#003700', '#002966', '#3d1466', 'custom-background'] },
        'clean'],
    ],
    handlers: customHandler
  }
};

//for format quill
const formatsQuill = [
  'header', 'font', 'size',
  'bold', 'italic', 'underline', 'strike', 'blockquote',
  'list', 'bullet', 'indent', 'align',
  'link', 'image', 'background', 'color',
];

const RowOption = [
  { value: '1', label: '1' },
  { value: '2', label: '2' },
  { value: '3', label: '3' },
  { value: '4', label: '4' },
  { value: '5', label: '5' },
  { value: '6', label: '6' },
  { value: '7', label: '7' },
  { value: '8', label: '8' },
  { value: '9', label: '9' },
  { value: '10', label: '10' },
  { value: '11', label: '11' },
  { value: '12', label: '12' }
];

const ColumnsOption = [
  { value: '0', label: 'Auto' },
  { value: '1', label: '1' },
  { value: '2', label: '2' },
  { value: '3', label: '3' },
  { value: '4', label: '4' },
  { value: '5', label: '5' }
];

const GapOption = [
  { value: '0', label: '0' },
  { value: '2', label: '2' },
  { value: '10', label: '10' },
  { value: '20', label: '20' },
  { value: '30', label: '30' },
  { value: '40', label: '40' },
  { value: '50', label: '50' }
];

const ImagePaddingOption = [
  { value: '0', label: '0' },
  { value: '1', label: '1' },
  { value: '2', label: '2' },
  { value: '3', label: '3' },
  { value: '4', label: '4' },
  { value: '5', label: '5' },
  { value: '6', label: '6' },
  { value: '7', label: '7' },
  { value: '8', label: '8' },
  { value: '9', label: '9' },
  { value: '10', label: '10' },
  { value: '11', label: '11' },
  { value: '12', label: '12' },
  { value: '13', label: '13' },
  { value: '14', label: '14' },
  { value: '15', label: '15' },
  { value: '16', label: '16' },
  { value: '17', label: '17' },
  { value: '18', label: '18' },
  { value: '19', label: '19' },
  { value: '20', label: '20' },
  { value: '21', label: '21' },
  { value: '22', label: '22' },
  { value: '23', label: '23' },
  { value: '24', label: '24' },
  { value: '25', label: '25' },
  { value: '26', label: '26' },
  { value: '27', label: '27' },
  { value: '28', label: '28' },
  { value: '29', label: '29' },
  { value: '30', label: '30' },
];

const ScrollOption = [
  { value: '1', label: '1' },
  { value: '2', label: '2' },
  { value: '3', label: '3' },
  { value: '4', label: '4' },
  { value: '5', label: '5' },
  { value: '6', label: '6' },
  { value: '7', label: '7' },
  { value: '8', label: '8' },
  { value: '9', label: '9' },
  { value: '10', label: '10' }
];

const renderThumb = ({ style, ...props }) => {
  const thumbStyle = {
    borderRadius: 6,
    backgroundColor: 'rgba(35, 49, 86, 0.8)'
  };
  return <div className="scroll-stick" style={{ ...style, ...thumbStyle }} {...props} />;
};

const CustomScrollbars = props => (
  <Scrollbars
    autoHide
    renderThumbHorizontal={renderThumb}
    renderThumbVertical={renderThumb}
    {...props} />
);


const LayoutCard = ({
  cnf,
  arrLylt,
  currLayoutId,
  updateLayoutById,
  handleCnfChange,
  handleEditorFocus,
  cn,
  fnCheckFieldIsDisplayOrNot,
  currLayout,
  widgetType,
  handleUpgradePlan
}) => {
  var style = document.createElement('style');
  document.head.appendChild(style);
  //create dynemic value dropdown for editor
  let arrChips = ['ICON', 'STAR', 'COUNT', 'AVERAGE', 'SOURCE'];
  toolbarModuleWithoutFontSize.container[0][0].custTagDropDown = arrChips;
  for (let i = 0; i < arrChips.length; i++) {
    const e = arrChips[i];
    style.sheet.insertRule('.ql-picker-options span[data-value=' + e + ']::before {content: "{{' + e + '}}" !important;}');
    style.sheet.insertRule('.ql-picker-label[data-value=' + e + ']::before {content: "Dynamic Value" !important;}');
  }

  //for floating badge layout
  let arrFloatingChips = ['BADGE_RATING', 'BADGE_STAR', 'BADGE_TOTAL_COUNT'];
  toolbarForFloatingBadge.container[0][0].custTagDropDown = arrFloatingChips;
  for (let i = 0; i < arrFloatingChips.length; i++) {
    const e = arrFloatingChips[i];
    style.sheet.insertRule('.ql-picker-options span[data-value=' + e + ']::before {content: "{{' + e + '}}" !important;}');
    style.sheet.insertRule('.ql-picker-label[data-value=' + e + ']::before {content: "Dynamic Value" !important;}');
  }

  if (document.getElementsByClassName('scroll-stick')) {
    let node = document.getElementsByClassName('scroll-stick');
    setTimeout(() => {
      for (let i = 0; i < node.length; i++) {
        const e = node[i];
        e.parentNode.classList.add('scroll-box');
      }
    }, 1);
  }
  return (
    <div className="tabs-layout-content">
      <CustomScrollbars className="editor-side-panel">
        <div>
          <SelectTemplateCard
            arrLylt={arrLylt}
            currLayoutId={currLayoutId}
            updateLayoutById={updateLayoutById} />

          {cnf &&
            <div className="card card-editor card-customize mt-15" style={{ display: fnCheckFieldIsDisplayOrNot('badge_setting', currLayout) ? 'block' : 'none' }}>
              <div className="card-editor-block p-0">
                <div className='card-plan-div'>
                  <label className="card-editor-title">Badge setting</label>
                  <UpgradePlanCard
                    handleUpgradePlan={handleUpgradePlan}
                  />
                </div>
                <div className="customize-list">
                  {cnf.bdgisrc != undefined &&
                    <PostToggleCard
                      ttl={'Show source'}
                      fieldName={'bdgisrc'}
                      value={cnf.bdgisrc}
                      handleCnfChange={handleCnfChange} />

                    // <div className="editor-toggle">
                    //   <label className="label-title">Show source</label>
                    //   <label className="switch">
                    //     <input type="checkbox" checked={cnf.bdgisrc} onChange={(e) => handleCnfChange('bdgisrc', e.target.checked)} />
                    //     <span className="slider round"></span>
                    //   </label>
                    // </div>
                  }
                  {cnf.bdgttltxt != undefined &&
                    <div className="editor-input header-editor-ckeditor editor-header-caption">
                      <label className="label-title">Title</label>
                      {cn == 'review' ?
                        <ReactQuill value={cnf.bdgttltxt} className='editor-ckeditor-input hideEditor bdgttltxt bgclr' modules={modulesFloatingBadgeQuill} formats={formatsQuill}
                          onChange={(newValue, delta, source) => {
                            if (source === 'user') {
                              handleCnfChange('bdgttltxt', newValue);
                            }
                          }}
                          onFocus={() => {
                            handleEditorFocus('bdgttltxt');
                          }} />
                        :
                        <ReactQuill value={cnf.bdgttltxt} className='editor-ckeditor-input hideEditor bdgttltxt bgclr' modules={modulesQuill} formats={formatsQuill}
                          onChange={(newValue, delta, source) => {
                            if (source === 'user') {
                              handleCnfChange('bdgttltxt', newValue);
                            }
                          }}
                          onFocus={() => {
                            handleEditorFocus('bdgttltxt');
                          }} />
                      }
                    </div>
                  }

                  {cnf.bdgrtntxt != undefined &&
                    <div className="editor-input header-editor-ckeditor editor-header-caption">
                      <label className="label-title">Rating text</label>
                      {cn == 'review' ?
                        <ReactQuill value={cnf.bdgrtntxt} className='editor-ckeditor-input hideEditor bdgrtntxt bgclr' modules={modulesFloatingBadgeQuill} formats={formatsQuill}
                          onChange={(newValue, delta, source) => {
                            if (source === 'user') {
                              handleCnfChange('bdgrtntxt', newValue);
                            }
                          }}
                          onFocus={() => {
                            handleEditorFocus('bdgrtntxt');
                          }} />
                        :
                        <ReactQuill value={cnf.bdgrtntxt} className='editor-ckeditor-input hideEditor bdgrtntxt bgclr' modules={modulesQuill} formats={formatsQuill}
                          onChange={(newValue, delta, source) => {
                            if (source === 'user') {
                              handleCnfChange('bdgrtntxt', newValue);
                            }
                          }}
                          onFocus={() => {
                            handleEditorFocus('bdgrtntxt');
                          }} />
                      }
                    </div>
                  }

                  {cnf.bdgcptntxt != undefined &&
                    <div className="editor-input header-editor-ckeditor editor-header-caption">
                      <label className="label-title">Caption</label>
                      {cn == 'review' ?
                        <ReactQuill value={cnf.bdgcptntxt} className='editor-ckeditor-input hideEditor bdgcptntxt bgclr' modules={modulesFloatingBadgeQuill} formats={formatsQuill}
                          onChange={(newValue, delta, source) => {
                            if (source === 'user') {
                              handleCnfChange('bdgcptntxt', newValue);
                            }
                          }}
                          onFocus={() => {
                            handleEditorFocus('bdgcptntxt');
                          }} />
                        :
                        <ReactQuill value={cnf.bdgcptntxt} className='editor-ckeditor-input hideEditor bdgcptntxt bgclr' modules={modulesQuill} formats={formatsQuill}
                          onChange={(newValue, delta, source) => {
                            if (source === 'user') {
                              handleCnfChange('bdgcptntxt', newValue);
                            }
                          }}
                          onFocus={() => {
                            handleEditorFocus('bdgcptntxt');
                          }} />
                      }
                    </div>
                  }
                </div>
              </div>
            </div>
          }

          {cnf && cnf.ihdr != undefined &&
            <div className="card card-editor card-header mt-15" style={{ display: fnCheckFieldIsDisplayOrNot('is_header', currLayout) ? 'block' : 'none' }}>
              <div className="card-editor-block p-0">
                <div className='card-plan-div'>
                  <label className="card-editor-title">Header</label>
                  <UpgradePlanCard
                    handleUpgradePlan={handleUpgradePlan}
                  />
                </div>
                <div className="header-list">
                  <PostToggleCard
                    className={'editor-toggle-contentwt editor-toggle-fullwt'}
                    ttl={'Show header'}
                    fieldName={'ihdr'}
                    value={cnf.ihdr}
                    handleCnfChange={handleCnfChange}>
                    <div className="width10x" style={{ display: cnf.ihdr ? 'block' : 'none' }}>
                      {cnf.hdttxt != undefined && (currLayoutId !== '630a03d7f13531ca03c5b0d8' && currLayoutId !== '632198caf8c6040c2ba3cb98') &&
                        <div className="editor-input header-editor-ckeditor editor-header-title width10x ">
                          <label className="label-title">Title</label>
                          {cn == 'review' ?
                            <ReactQuill value={cnf.hdttxt} className='editor-ckeditor-input hideEditor hdttxt crdbg' modules={modulesPreventEnterQuill} formats={formatsQuill}
                              onChange={(newValue, delta, source) => {
                                if (source === 'user') {
                                  handleCnfChange('hdttxt', newValue);
                                }
                              }}
                              onFocus={() => {
                                handleEditorFocus('hdttxt');
                              }} />
                            :
                            <ReactQuill value={cnf.hdttxt} className='editor-ckeditor-input hideEditor hdttxt crdbg' modules={modulesQuill} formats={formatsQuill}
                              onChange={(newValue, delta, source) => {
                                if (source === 'user') {
                                  handleCnfChange('hdttxt', newValue);
                                }
                              }}
                              onFocus={() => {
                                handleEditorFocus('hdttxt');
                              }} />
                          }
                        </div>
                      }
                      {cnf.cptxt != undefined &&
                        <div className="editor-input header-editor-ckeditor editor-header-caption width10x">
                          <label className="label-title">Caption</label>
                          {cn == 'review' ?
                            <ReactQuill value={cnf.cptxt} className='editor-ckeditor-input hideEditor cptxt crdbg' modules={modulesPreventEnterQuill} formats={formatsQuill}
                              onChange={(newValue, delta, source) => {
                                if (source === 'user') {
                                  handleCnfChange('cptxt', newValue);
                                }
                              }}
                              onFocus={() => {
                                handleEditorFocus('cptxt');
                              }} />
                            :
                            <ReactQuill value={cnf.cptxt} className='editor-ckeditor-input hideEditor cptxt crdbg' modules={modulesQuill} formats={formatsQuill}
                              onChange={(newValue, delta, source) => {
                                if (source === 'user') {
                                  handleCnfChange('cptxt', newValue);
                                }
                              }}
                              onFocus={() => {
                                handleEditorFocus('cptxt');
                              }} />
                          }
                        </div>
                      }

                      {cnf.iwarbtn != undefined &&
                        <div className="editor-toggle customize-dropdown toggle-header-dply">
                          <label className="label-title">Show write a review button</label>
                          <label className="switch">
                            <input type="checkbox" checked={cnf.iwarbtn ? true : false} onChange={(e) => handleCnfChange('iwarbtn', e.target.checked)} />
                            <span className="slider round"></span>
                          </label>
                        </div>
                      }
                      {cnf.warbtntxt != undefined &&
                        <div className="editor-input header-editor-ckeditor editor-header-title" style={{ display: cnf.iwarbtn ? 'block' : 'none' }}>
                          <ReactQuill value={cnf.warbtntxt} className='editor-ckeditor-input hideEditor warbtntxt crdbg' modules={modulesQuillForWriteReview} formats={formatsQuill}
                            onChange={(newValue, delta, source) => {
                              if (source === 'user') {
                                handleCnfChange('warbtntxt', newValue);
                              }
                            }}
                            onFocus={() => {
                              handleEditorFocus('warbtntxt');
                            }} />
                        </div>
                      }
                      {cnf.iwarbtn == true &&
                        <div className="header-check">
                          <label className="radio label-nrm rdrct-dynmc-cutm">
                            <input type='radio' checked={!cnf.icstwarbtntxt} onChange={(e) => handleCnfChange('icstwarbtntxt', !e.target.checked)} />
                            <span className="checkround"></span>
                            <span className="radio-label">Redirect to dynamic review URL </span>
                          </label>
                          <label className="radio label-nrm rdrct-dynmc-cutm">
                            <input type='radio' value={cnf.icstwarbtntxt} checked={cnf.icstwarbtntxt} onChange={(e) => handleCnfChange('icstwarbtntxt', e.target.checked)} />
                            <span className="checkround"></span>
                            <span className="radio-label"> Redirect to custom URL </span>
                          </label>
                          {cnf.icstwarbtntxt == true &&
                            <div className="editor-input header-editor-ckeditor editor-header-title">
                              <input className='editor-ckeditor-input hideEditor warbtntxt crdbg header-Edt-inpt-ONly' type="text" placeholder='Add Custom URL' value={cnf.csturlwarbtntxt} onChange={(e) => handleCnfChange('csturlwarbtntxt', e.target.value)} />
                            </div>
                          }
                        </div>
                      }
                    </div>
                  </PostToggleCard>
                  {/* <div className="editor-field-list editor-toggle">
                    <label className="label-title">Show header</label>
                    <label className="switch">
                      <input type="checkbox" checked={cnf.ihdr ? true : false} onChange={(e) => handleCnfChange('ihdr', e.target.checked)} />
                      <span className="slider round"></span>
                    </label>
                  </div> */}
                </div>
              </div>
            </div>
          }
          {/* Tab section */}
          {cnf && cnf.rvitb != undefined && fnCheckFieldIsDisplayOrNot('tab_section', currLayout) &&
            <div className="card card-editor card-customize mt-15">
              <div className="card-editor-block p-0">
                <div className='card-plan-div'>
                  <label className="card-editor-title">Tab section</label>
                  <UpgradePlanCard
                    handleUpgradePlan={handleUpgradePlan}
                  />
                </div>
                <div className="customize-list">
                  {currLayoutId == '630a03d7f13531ca03c5b0d8' || currLayoutId == '632198caf8c6040c2ba3cb98' ?
                    <div className="editor-input header-editor-ckeditor editor-header-title" style={{
                      padding: '14px', border: '1px solid rgba(131, 146, 165, 0.3)', borderRadius: '7px', margin: '0'
                    }}>
                      <label className="label-title">Overall rating text</label>
                      <input className='editor-input-content editor-input-fullwidth editor-input-inckey' type='text' value={cnf.rvallttl} onChange={(e) => handleCnfChange('rvallttl', e.target.value)} />
                    </div>
                    :
                    <PostToggleCard
                      className={'editor-toggle-contentwt editor-toggle-fullwt'}
                      ttl={'Display tab section'}
                      fieldName={'rvitb'}
                      value={cnf.rvitb}
                      handleCnfChange={handleCnfChange}>
                      {cnf.rvitb &&
                        <div className="width10x">
                          {cnf.rvttl != undefined &&
                            <div className="editor-input header-editor-ckeditor editor-header-title">
                              <label className="label-title">Title text</label>
                              <ReactQuill value={cnf.rvttl} className='editor-ckeditor-input hideEditor rvttl crdbg' modules={modulesPreventEnterQuill} formats={formatsQuill}
                                onChange={(newValue, delta, source) => {
                                  if (source === 'user') {
                                    handleCnfChange('rvttl', newValue);
                                  }
                                }}
                                onFocus={() => {
                                  handleEditorFocus('rvttl');
                                }} />
                            </div>
                          }
                          {cnf.rviall != undefined &&
                            <div className="editor-toggle customize-dropdown toggle-header-dply mt-2">
                              <label className="label-title">Show "All" tab</label>
                              <label className="switch">
                                <input type="checkbox" checked={cnf.rviall ? true : false} onChange={(e) => handleCnfChange('rviall', e.target.checked)} />
                                <span className="slider round"></span>
                              </label>
                            </div>
                          }
                          {cnf.rviall && cnf.rvall != undefined &&
                            <div className="editor-input header-editor-ckeditor editor-header-title">
                              <label className="label-title">Set label for "All" tab</label>
                              <input className='editor-input-content editor-input-fullwidth editor-input-inckey' type='text' value={cnf.rvall} onChange={(e) => handleCnfChange('rvall', e.target.value)} />
                            </div>
                          }
                          {cnf.rvallttl != undefined &&
                            <div className="editor-input header-editor-ckeditor editor-header-title">
                              <label className="label-title">Overall rating text</label>
                              <input className='editor-input-content editor-input-fullwidth editor-input-inckey' type='text' value={cnf.rvallttl} onChange={(e) => handleCnfChange('rvallttl', e.target.value)} />
                            </div>
                          }
                        </div>
                      }
                    </PostToggleCard>
                  }
                  {/* <div className="editor-toggle customize-dropdown toggle-header-dply">
                    <label className="label-title">Tab section display</label>
                    <label className="switch">
                      <input type="checkbox" checked={cnf.rvitb ? true : false} onChange={(e) => handleCnfChange('rvitb', e.target.checked)} />
                      <span className="slider round"></span>
                    </label>
                  </div> */}
                </div>
              </div>
            </div>
          }
          {cnf && (cnf.drw != undefined || cnf.dclm != undefined || cnf.crdgp != undefined) && fnCheckFieldIsDisplayOrNot('pagination', currLayout) &&
            <div className="card card-editor card-customize mt-15">
              <div className="card-editor-block p-0">
                <div className='card-plan-div'>
                  <label className="card-editor-title">Customize</label>
                  <UpgradePlanCard
                    handleUpgradePlan={handleUpgradePlan}
                  />
                </div>
                <div className="customize-list">
                  {fnCheckFieldIsDisplayOrNot('cnf.drw', currLayout) && cnf.drw != undefined &&
                    <div className="editor-field-list editor-dropdown customize-dropdown customize-rows">
                      <label>Rows</label>
                      <Dropdown className="nf-select-dropdown nf-select-defaultdd" options={RowOption} value={cnf.drw ? cnf.drw.toString() : cnf.drw} onChange={(e) => handleCnfChange('drw', e.value)} />
                    </div>
                  }
                  {fnCheckFieldIsDisplayOrNot('cnf.dclm', currLayout) && cnf.dclm != undefined &&
                    <div className="editor-field-list editor-dropdown customize-dropdown customize-coloms">
                      <label>Columns</label>
                      <Dropdown className="nf-select-dropdown nf-select-defaultdd" options={ColumnsOption} value={cnf.dclm != undefined ? cnf.dclm.toString() : cnf.dclm} onChange={(e) => handleCnfChange('dclm', e.value)} />
                    </div>
                  }
                  {cnf.crdgp != undefined &&
                    <div className="editor-field-list editor-dropdown customize-dropdown customize-gap ">
                      <label>Gap</label>
                      <Dropdown className="nf-select-dropdown nf-select-defaultdd" options={GapOption} value={cnf.crdgp ? cnf.crdgp.toString() : cnf.crdgp} onChange={(e) => handleCnfChange('crdgp', e.value)} />
                    </div>
                  }
                  {cnf.crdimgpd != undefined &&
                    <div className="editor-field-list editor-dropdown customize-dropdown">
                      <label>Image padding</label>
                      <Dropdown className="nf-select-dropdown nf-select-defaultdd" options={ImagePaddingOption} value={cnf.crdimgpd ? cnf.crdimgpd.toString() : cnf.crdimgpd} onChange={(e) => handleCnfChange('crdimgpd', e.value)} />
                    </div>
                  }
                </div>
              </div>
            </div>
          }
          {cnf && cnf.lmpst != undefined && fnCheckFieldIsDisplayOrNot('cnf.lmpst', currLayout) &&
            <div className="card card-editor card-lord-btn mt-15">
              <div className="card-editor-block p-0">
                <div className='card-plan-div'>
                  <label className="card-editor-title">Load more button</label>
                  <UpgradePlanCard
                    handleUpgradePlan={handleUpgradePlan}
                  />
                </div>
                <div className="lord-btn-list">

                  <div className="editor-field-list card-editor-row card-editor-lordbtn ">
                    <label className="radio label-nrm">
                      <input type='radio' value={'2'} checked={cnf.lmpst == '2'} onChange={(e) => handleCnfChange('lmpst', e.target.value)} />
                      <span className="checkround"></span>
                      <span className="radio-label"> On button click </span>
                    </label>
                    {
                      cnf.lmpst == '2' &&
                      <div className="editor-input header-editor-ckeditor editor-header-title editor-btn-name">
                        <label className="label-title">Button name</label>
                        <ReactQuill value={cnf.ldmrtxt} className='editor-ckeditor-input hideEditor ldmrtxt' modules={modulesFontSizeQuill} formats={formatsQuill}
                          onChange={(newValue, delta, source) => {
                            if (source === 'user') {
                              handleCnfChange('ldmrtxt', newValue);
                            }
                          }}
                          onFocus={() => {
                            handleEditorFocus('ldmrtxt');
                          }} />
                      </div>
                    }
                  </div>

                  <div className="editor-field-list card-editor-row card-editor-lordbtn card-editor-autoscr">
                    <label className="radio label-nrm">
                      <input type='radio' value={'0'} checked={cnf.lmpst == '0'} onChange={(e) => handleCnfChange('lmpst', e.target.value)} />
                      <span className="checkround"></span>
                      <span className="radio-label">Autoscroll</span>
                    </label>
                    {
                      cnf.lmpst == '0' &&
                      <div className="editor-dropdown customize-dropdown customize-gap ">
                        <label>Scroll speed</label>
                        <Dropdown className="nf-select-dropdown nf-select-defaultdd" options={ScrollOption} value={cnf.scrspd ? cnf.scrspd.toString() : cnf.scrspd} onChange={(e) => handleCnfChange('scrspd', e.value)} />
                      </div>
                    }
                    <div>
                      {
                        (cnf.lmpst == '0' && cnf.ihgtat == true) &&
                        <label className='scroll-info-msg'>Turn off Auto height</label>
                      }
                    </div>
                  </div>

                  <div className="editor-field-list card-editor-row card-editor-lordbtn card-editor-laylod">
                    <label className="radio label-nrm lazyload-div">
                      <input type='radio' value={'1'} checked={cnf.lmpst == '1'} onChange={(e) => handleCnfChange('lmpst', e.target.value)} />
                      <span className="checkround"></span>
                      <span className="radio-label"> Lazyload </span>
                    </label>
                    <div>
                      {
                        (cnf.lmpst == '1' && cnf.ihgtat == true) &&
                        <label className='scroll-info-msg'>Turn off Auto height</label>
                      }
                    </div>
                  </div>

                </div>
              </div>
            </div>
          }
          {/*currLayoutId=='632198caf8c6040c2ba3cb98' show scroll speed in auto_slider layout */}
          {cnf && ((cnf.isarw != undefined || cnf.iartt != undefined) || currLayoutId == '6327f0fe463bccfe7761711e' || currLayoutId == '632462bc9bd738e98c9618d2') && fnCheckFieldIsDisplayOrNot('cnf.artspd', currLayout) &&
            <div className="card card-editor card-header mt-15">
              <div className="card-editor-block p-0">
                <div className='card-plan-div'>
                  <label className="card-editor-title">Configuration</label>
                  <UpgradePlanCard
                    handleUpgradePlan={handleUpgradePlan}
                  />
                </div>
                <div className="customize-list">
                  {cnf && cnf.isarw != undefined && fnCheckFieldIsDisplayOrNot('cnf.isarw', currLayout) &&
                    <PostToggleCard
                      ttl={'Show arrow'}
                      fieldName={'isarw'}
                      value={cnf.isarw}
                      handleCnfChange={handleCnfChange} />

                    // <div className="editor-toggle customize-dropdown toggle-header-dply">
                    //   <label className="label-title">Show arrow</label>
                    //   <label className="switch">
                    //     <input type="checkbox" checked={cnf.isarw ? true : false} onChange={(e) => handleCnfChange('isarw', e.target.checked)} />
                    //     <span className="slider round"></span>
                    //   </label>
                    // </div>
                  }
                  {cnf && cnf.iartt != undefined && fnCheckFieldIsDisplayOrNot('cnf.iartt', currLayout) &&
                    <PostToggleCard
                      ttl={'Auto rotate'}
                      fieldName={'iartt'}
                      value={cnf.iartt}
                      handleCnfChange={handleCnfChange} />

                    // <div className="editor-toggle customize-dropdown toggle-header-dply">
                    //   <label className="label-title">Auto rotate</label>
                    //   <label className="switch">
                    //     <input type="checkbox" checked={cnf.iartt ? true : false} onChange={(e) => handleCnfChange('iartt', e.target.checked)} />
                    //     <span className="slider round"></span>
                    //   </label>
                    // </div>
                  }
                  {/* Default show in auto_slider using layout id */}
                  {cnf && (cnf.iartt == true || currLayoutId == '632198caf8c6040c2ba3cb98' || currLayoutId == '6327f0fe463bccfe7761711e') &&
                    <div className="editor-dropdown customize-dropdown customize-gap">
                      <label>Scroll speed</label>
                      <Dropdown className="nf-select-dropdown nf-select-defaultdd" options={ScrollOption} value={cnf.artspd ? cnf.artspd.toString() : cnf.artspd} onChange={(e) => handleCnfChange('artspd', e.value)} />
                    </div>
                  }
                </div>
              </div>
            </div>
          }

          {cnf && cnf.irspn != undefined && fnCheckFieldIsDisplayOrNot('custom_width', currLayout) &&
            <CustomWidthCard
              cnf={cnf}
              handleCnfChange={handleCnfChange}
              handleUpgradePlan={handleUpgradePlan} />
          }

          {/* CTA lable */}
          {
            cnf && (cnf.tlsibtn != undefined || cnf.tlsbtnclksmtb != undefined) &&
            <CtaLableCard
              cnf={cnf}
              handleCnfChange={handleCnfChange}
              widgetType={widgetType} />
          }

        </div>
      </CustomScrollbars >
    </div >
  );
};

export default LayoutCard;


// WEBPACK FOOTER //
// ./src/components/Widget/LayoutCard.js